import { Attendee } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<EntityType<Attendee>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const changeAdminAttendeeStatusReducer = createReducer<State, Actions>(initialState, {
  [actions.changeAdminAttendeeStatus.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.changeAdminAttendeeStatus.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.changeAdminAttendeeStatus.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.changeAdminAttendeeStatus.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default changeAdminAttendeeStatusReducer;
